import React from "react";
import aboutimage from "../Assets/Images/abou.png";
import about2image from "../Assets/Images/about-2.png";
import Teamslider from './Teamslider';
import "./About.css";
// import Lottie from 'react-lottie-player';
// import lottie1 from '../Assets/Images/lotties/about1.json';
// import lottie2 from '../Assets/Images/lotties/about2.json';

const About = () => {
  return (
    <div id="About" className="Portfolio-container">
      <div className="container">
        <div style={{ fontSize: 20, fontWeight: 500, textAlign: "center", color: "#1E978C" }}> About Us</div>
        <h1>Who We Are </h1>

        <p className="text" style={{ fontSize: "medium" }}>
          Aizonix Solutions specializes in AI-powered software development, serving clients worldwide with smart, scalable digital solutions.
        </p>
        <div className="About-text-img">
          <img className="aboutimage" src={aboutimage} alt="about" />
          {/* <Lottie play animationData={lottie1} loop style={{ height: 400, width: 600 }} /> */}
          <div>
            <strong>Meet Aizonix Solutions</strong> <br />
            <p className="para">
              Aizonix Solutions was established in 2024 to provide AI-powered IT solutions for small to medium-sized businesses. Our mission since the very first day has been to cultivate professional relationships with our clients by providing effective and reliable AI-generated IT solutions tailored to their needs. The team at Aizonix Solutions is equipped with a highly developed skill set and experience, not only in Information Technology but also in business processes across a range of industry sectors. This business experience makes us uniquely positioned to offer solutions that promise greater operational efficiency, productivity gains, and cost savings for each of our clients, regardless of their industry. At Aizonix Solutions, we guarantee rapid, reliable, and robust information technology solutions that work best in the industry. No client or task is too big or too small for us. If you want your business to look better, you've come to the right place.
            </p>
          </div>
        </div>
        <div className="About-text-img2">
          <div>
            <strong>Our Mission</strong> <br />
            <div>
              <p className="para">
                To deliver bug-free, turnkey AI-powered IT solutions to our clients with outstanding infrastructure, design, and development.
              </p>
            </div>
            <br />
            <strong>Our Excellence</strong> <br />
            <div>
              <p className="para">
                Our excellence in multiple latest technological fields not only makes us unique but also increases our authenticity in the digital market. We assist ventures in creating something immense with our revolutionary approach to AI-centered solutions. If you want your business to look better and create more, you’ve come to the right place.

              </p>
            </div>
            <br />
            <strong>Smart Digital Solutions</strong> <br />
            <div>
              <p className="para">
                From mobile apps to websites to marketing, we use AI and automation to drive real results. Whether you're launching a startup or scaling an existing business—we’ve got your back with future-ready solutions.

              </p>
            </div>
          </div>
          <img className="aboutimage2" src={about2image} alt="about" />
          {/* <Lottie play animationData={lottie2} loop style={{ height: 400, width: 600 }} /> */}
        </div>
      </div>
      <Teamslider />
    </div>
  );
};

export default About;
